import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ProofMethodInfo36q47k2opsjdz as ProofMethodInfo,
  ProofOption3e15jtcqm4fpv as ProofOption,
} from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/proofModels.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_property() {
  return null;
}
function get_primaryIdentifierRequired() {
  return true;
}
function *supported($completion) {
  return true;
}
function get_earlyProof() {
  return null;
}
function render(to, primaryIdentifier, checks, onResult) {
  var tmp;
  if (primaryIdentifier == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Frame())(to.get_context_h02k06_k$());
    ensureOutermostElement(element);
    to.willAddChild_hz2iwc_k$(element);
    text(element, 'How... how did you get here?');
    element.onStartup_vrxh3i_k$();
    to.addChild_2qpft2_k$(element);
    return Unit_instance;
  } else {
    tmp = primaryIdentifier;
  }
  var primaryIdentifier_0 = tmp;
  var tmp2_safe_receiver = checks == null ? null : checks.options_1;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp2_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s.next_20eer_k$();
        if (element_0.method_1.via_1 === this.get_via_18itzv_k$()) {
          tmp$ret$5 = element_0;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    tmp_0 = tmp$ret$5;
  }
  var tmp3_elvis_lhs = tmp_0;
  var option = tmp3_elvis_lhs == null ? new (ProofOption())(new (ProofMethodInfo())(this.get_via_18itzv_k$(), primaryIdentifier_0.property_1), primaryIdentifier_0.value_1) : tmp3_elvis_lhs;
  return this.render_1v1gc7_k$(to, primaryIdentifier_0, option, onResult);
}
function render_0(to, primaryIdentifier, checks, proofs, onResult) {
  return this.render_7yvau5_k$(to, primaryIdentifier, checks, onResult);
}
var ProofComponentClass;
function ProofComponent() {
  if (ProofComponentClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProofComponent', VOID, VOID, VOID, [0]);
    ProofComponentClass = $;
  }
  return ProofComponentClass;
}
//region block: exports
export {
  get_earlyProof as get_earlyProof3ov5nyo7j4x3i,
  get_primaryIdentifierRequired as get_primaryIdentifierRequired2nrw4m53j4kyj,
  render_0 as render2cu0olic2aw04,
  render as render29rcl1dh9m4ii,
  ProofComponent as ProofComponent2u514n64q2oz3,
  supported as supportedplmnts7qxgra,
};
//endregion

//# sourceMappingURL=ProofComponent.mjs.map
